import { createReducer } from '@reduxjs/toolkit';

import { login, logout, setProfile } from 'redux/actions/login';

import localStore from 'utils/local_store';

const defaultInitialState = {
  authenticatedUser: undefined,
  profile: undefined,
};

export const initialState = () => {
  const user = localStore.get('user');

  if (user != null) {
    return { ...defaultInitialState, authenticatedUser: user };
  }

  return defaultInitialState;
};

const LoginReducer = createReducer(initialState(), {
  [login]: (state, action) => {
    localStore.set('user', action.payload);

    return {
      ...defaultInitialState,
      authenticatedUser: action.payload,
    };
  },
  [logout]: (state, action) => {
    localStore.unset('user');
    return defaultInitialState;
  },
  [setProfile]: (state, action) => {
    state.profile = action.payload;
  },
});

export default LoginReducer;
